// extracted by mini-css-extract-plugin
module.exports = {"point":"Point_point__3IhaA","btnBuy":"Point_btnBuy__24MHh","numberPoint":"Point_numberPoint__26ZyI","pointBox":"Point_pointBox__1tkI3","rotate":"Point_rotate__3K1a3"};